import gql from 'graphql-tag';

export const GET_EQUIPMENT_ASSETS = gql`
  query GetEquipmentImages($input: EquipmentAssetsInput!) {
    equipment {
      result: assets(input: $input) {
        assets {
          id
          type
          source
          createdDateTime
        }
      }
    }
  }
`;
